module.exports = __webpack_public_path__ + "img/reviews-16.28a9905d.jpg";